import React from 'react'
import { Box, Typography } from '@the-platform-group/component-library'
import { Work as WorkIcon } from '@the-platform-group/component-library/Icons'

/**
 * Details Card Component that displays the details of the contact
 * @param {Object} startIcon - The icon to display on the left side of the details card
 * @param {string} title - The title of the details card
 * @param {Array} values - The values to display in the details card
 * @param {Function} getValue - The function to get the value of the details card
 * @param {React.Component} endIcon - The icon to display on the right side of the details card
 * @returns {React.Component} - The DetailsCard component that displays the details of the contact
 */
const DetailsCard = ({
  startIcon = <WorkIcon width={16} height={16} />,
  title,
  values = [],
  getValue = value => value,
  endIcon = null,
}) => {
  if (values?.length < 1 && !values) {
    return null
  }

  return (
    <Box display="flex" flexDirection="row" gap={1} sx={{ width: '100%' }}>
      <Box sx={{ width: 18, height: 18 }}>{startIcon}</Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {title && (
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
        )}
        {Array.isArray(values)
          ? values.map(value => <Typography variant="body2">{getValue(value)}</Typography>)
          : values && <Typography variant="body2">{values}</Typography>}
      </Box>
      {endIcon}
    </Box>
  )
}

export default DetailsCard
